var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 464 464",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M380.377,436.829l-9.188-68.908c-1.962-14.711-11.908-27.128-25.837-32.253l-54.412-20.021   c-6.533-2.178-10.94-8.292-10.94-15.179v-25.802l34.461-14.359C332.349,252.855,344,235.378,344,216v-8c13.255,0,24-10.745,24-24   s-10.745-24-24-24v-16c0-22.091-17.909-56-40-56H160c-22.092,0-40,33.909-40,56v16c-13.255,0-24,10.745-24,24s10.745,24,24,24v8   c0,19.377,11.651,36.854,29.538,44.308L184,274.667v25.801c0,6.887-4.407,13.001-10.94,15.179l-54.412,20.021   c-13.929,5.125-23.875,17.542-25.837,32.253l-9.188,68.908C81.705,451.216,92.897,464,107.412,464h249.176   C371.103,464,382.296,451.216,380.377,436.829z",
    fill: "#b6825d",
    "data-original": "#f6b47b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M351.992,200h-16c0,0-7.62,21.092-8,47.999c-0.213,15.07,3.692,31.966,8,48.001h16   c4.308-16.036,8.213-32.931,8-48.001C359.612,221.092,351.992,200,351.992,200z",
    fill: "#6e4439",
    "data-original": "#6e4439",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M128,200h-16c0,0-7.62,21.092-8,47.999c-0.213,15.07,3.692,31.966,8,48.001h16   c4.308-16.036,8.213-32.931,8-48.001C135.62,221.092,128,200,128,200z",
    fill: "#553732",
    "data-original": "#5e342e",
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M116.192,148.31H72.008c-5.66,0-9.53,5.716-7.428,10.971l8.123,20.307    c1.83,4.574,7.319,6.424,11.544,3.889l31.945-19.167V148.31z",
    fill: "#8bce27",
    "data-original": "#f23f44",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M116.192,148.31H72.008c-5.66,0-9.53-5.716-7.428-10.971l8.123-20.307    c1.83-4.574,7.319-6.424,11.544-3.889l31.945,19.167V148.31z",
    fill: "#d8ff44",
    "data-original": "#ff4f4f",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M347.809,148.31h44.184c5.66,0,9.53,5.716,7.428,10.971l-8.123,20.307    c-1.83,4.574-7.319,6.424-11.544,3.889l-31.945-19.167V148.31z",
    fill: "#8bce27",
    "data-original": "#f23f44",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M347.809,148.31h44.184c5.66,0,9.53-5.716,7.428-10.971l-8.123-20.307    c-1.83-4.574-7.319-6.424-11.544-3.889l-31.945,19.167V148.31z",
    fill: "#d8ff44",
    "data-original": "#ff4f4f",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M280,274.667l-96-21.334v47.135c0,5.759-3.186,10.831-8.017,13.659    C243.077,325.871,280,274.667,280,274.667z",
    fill: "#966d50",
    "data-original": "#e2a071",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M120,160c-13.255,0-24,10.746-24,24c0,13.255,10.745,24,24,24v8    c0,19.378,11.651,36.855,29.538,44.308l51.692,21.539c9.749,4.062,20.207,6.154,30.769,6.154l0,0    c10.562,0,21.019-2.092,30.769-6.154l51.694-21.539C332.349,252.855,344,235.378,344,216v-8c13.255,0,24-10.745,24-24    s-10.745-24-24-24v-26c0-25.405-20.595-46-46-46H166c-25.405,0-46,20.595-46,46V160z",
    fill: "#c39772",
    "data-original": "#fdc88e",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M176,192L176,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8    C184,188.4,180.4,192,176,192z",
    fill: "#623f33",
    "data-original": "#623f33",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M288,192L288,192c-4.4,0-8-3.6-8-8v-8c0-4.4,3.6-8,8-8l0,0c4.4,0,8,3.6,8,8v8    C296,188.4,292.4,192,288,192z",
    fill: "#623f33",
    "data-original": "#623f33",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M232,248.219c-14.223,0-27.527-3.5-36.5-9.605c-3.652-2.484-4.602-7.461-2.113-11.113     c2.48-3.648,7.461-4.598,11.113-2.113c6.289,4.277,16.57,6.832,27.5,6.832s21.211-2.555,27.5-6.832     c3.66-2.492,8.629-1.539,11.113,2.113c2.488,3.652,1.539,8.629-2.113,11.113C259.528,244.719,246.223,248.219,232,248.219z",
    fill: "#966d50",
    "data-original": "#e2a071",
    className: ""
  }))), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M120,160c-13.255,0-24,10.745-24,24s10.745,24,24,24v8c0,19.378,11.651,36.855,29.538,44.308   l51.69,21.538c2.53,1.054,5.112,1.962,7.727,2.749c-22.844-16.711-38.05-31.32-46.96-40.872c-6.482-6.95-9.995-16.121-9.995-25.625   v-44.711c22.9-7.993,87.178-34.248,88-77.387l-10-10C230,86,225.667,143.333,120,160z",
    fill: "#b6825d",
    "data-original": "#f6b47b",
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M323.837,326.662l-28.787,46.058c-4.386,7.017-12.077,11.28-20.352,11.28h-85.396    c-8.275,0-15.966-4.263-20.352-11.28l-28.786-46.058c-2.312-3.699-7.16-4.864-10.9-2.62l-26.278,15.767    c-3.837,2.302-5.04,7.305-2.668,11.1L136,408h192l35.682-57.092c2.372-3.795,1.169-8.797-2.668-11.1l-26.278-15.767    C330.997,321.798,326.148,322.964,323.837,326.662z",
    fill: "#8bce27",
    "data-original": "#f23f44",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 408,
    style: {},
    width: 192,
    height: 56,
    fill: "#d8ff44",
    "data-original": "#ff4f4f",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M272,0c-26,0-40,8-40,8s-14-8-40-8S67.333,50.055,104,166.055c0,0,128-22.722,128-78.055   c0,55.333,128,78.055,128,78.055C396.667,50.055,298,0,272,0z",
    fill: "#6e4439",
    "data-original": "#6e4439",
    className: ""
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M232,8.004V8c0,0-14-8-40-8S67.334,50.055,104,166.055c0,0,15.495-2.757,35.69-8.67    C117.089,53.368,207.192,8.084,232,8.004z",
    fill: "#553732",
    "data-original": "#5e342e",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M128,312h-16c-4.418,0-8-3.582-8-8l0,0c0-4.418,3.582-8,8-8h16c4.418,0,8,3.582,8,8l0,0    C136,308.419,132.418,312,128,312z",
    fill: "#8bce27",
    "data-original": "#f23f44",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M128,312c0,0,14,24-8,56c-22-32-8-56-8-56",
    fill: "#553732",
    "data-original": "#5e342e",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M335.992,312h16c4.418,0,8-3.582,8-8l0,0c0-4.418-3.582-8-8-8h-16c-4.418,0-8,3.582-8,8l0,0    C327.992,308.419,331.574,312,335.992,312z",
    fill: "#d8ff44",
    "data-original": "#ff4f4f",
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M335.992,312c0,0-14,24,8,56c22-32,8-56,8-56",
    fill: "#6e4439",
    "data-original": "#6e4439",
    className: ""
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.cd84277bb5ea5d4a72c84ebce087854e.svg";
export { ForwardRef as ReactComponent };